document.addEventListener('DOMContentLoaded', ()=>{
  const hook = setInterval(()=>{
    let hulkDiv = document.querySelector('.hulkapps_product_options');
    if (hulkDiv) {
        console.log('loaded');
        clearInterval(hook);

        document.querySelectorAll('.hulk-swatch .hulkapps_option_value .hulkapps_swatch_option .hulk_po_radio, .hulk-swatch .hulkapps_mswatch_option .hulkapps-tooltip div .hulk_po_checkbox').forEach((element) => {
            const value = element.getAttribute('value');
            const price = element.getAttribute('data-price');
            
            const valueDisplay = document.createElement('div');
            valueDisplay.innerHTML = `<div>${value}</div><b><div>$${price}</div></b>`;
            valueDisplay.style.marginTop = '10px';
            valueDisplay.style.fontSize = '14px';
            valueDisplay.style.textAlign = "center";
            
            const parentLabel = element.closest('label');
            
            if (parentLabel) {
                parentLabel.appendChild(valueDisplay);
            }
        });

       // Frame reference data
// Frame reference data
const frameData = {
    "No Frame": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/1_No_Frame.png?v=1765365594",
    "Gallery Wrap": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/2_Gallery_wrap.jpg?v=1765365594",
    "Black Floater": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/3_Black_Floater_Frame.jpg?v=1765365593",
    "Brown Floater": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/4_Brown_Floater_Frame.jpg?v=1765365594",
    "Gold Floater": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/5_Gold_Floater_Frame.jpg?v=1765365594",
    "White and Gold": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/6_White_and_Gold.jpg?v=1765365594",
    "Black and Gold": "https://cdn.shopify.com/s/files/1/0174/2848/0100/files/7_Black_and_Gold.jpg?v=1765365594",
    "Antique Gold": "https://cdn.shopify.com/s/files/1/0638/5798/3628/files/8Antique_Gold.png?v=1764595634",
};

const mainParent = document.querySelector('.hulk-framing');
const optionName = mainParent.querySelector('.hulkapps_option_name');
const optionValue = mainParent.querySelector('.hulkapps_option_value');

// Create the preview display
const selectedSwatchDisplay = document.createElement('div');
selectedSwatchDisplay.className = 'selected-swatch-display';
selectedSwatchDisplay.style.cssText = 'width: 100%; padding-bottom: 15px;';
selectedSwatchDisplay.innerHTML = `
    <div class="swatch-preview" style="display: none;">
        <img src="" alt="" style="width: 170px; height: 170px; object-fit: cover; border: 1px solid #ddd;">
        <div class="swatch-name" style="margin-top: 8px; font-weight: 900;"></div>
        <div class="swatch-price" style="margin-top: 4px; color: #666;"></div>
    </div>
`;

// Insert preview after the option name but before the option value
optionName.parentNode.insertBefore(selectedSwatchDisplay, optionValue);

function updateSwatchDisplay() {
    // Check for checked radio button first
    let selectedRadio = document.querySelector('.hulk-framing input[type="radio"]:checked');
    
    // If no checked radio, look for default selected by class
    if (!selectedRadio) {
        const selectedDiv = document.querySelector('.hulk-framing .radio_div.radio_selected');
        if (selectedDiv) {
            const radioId = selectedDiv.getAttribute('for');
            selectedRadio = document.getElementById(radioId);
            if (selectedRadio) {
                selectedRadio.checked = true;
            }
        }
    }
    
    const previewContainer = selectedSwatchDisplay.querySelector('.swatch-preview');
    
    if (selectedRadio) {
        const frameName = selectedRadio.value;
        const frameImage = frameData[frameName];
        const framePrice = parseFloat(selectedRadio.getAttribute('data-price'));
        
        if (frameImage) {
            const imgElement = previewContainer.querySelector('img');
            const nameElement = previewContainer.querySelector('.swatch-name');
            const priceElement = previewContainer.querySelector('.swatch-price');
            
            imgElement.src = frameImage;
            imgElement.alt = frameName;
            nameElement.textContent = frameName;
            
            if (framePrice > 0) {
                priceElement.textContent = `+$${framePrice.toFixed(2)}`;
                priceElement.style.display = 'block';
            } else {
                priceElement.style.display = 'none';
            }
            
            previewContainer.style.display = 'flex';
        } else {
            previewContainer.style.display = 'none';
        }
    } else {
        previewContainer.style.display = 'none';
    }
}

document.querySelectorAll('.hulk-framing input[type="radio"]').forEach(radio => {
    radio.addEventListener('change', updateSwatchDisplay);
});

// Initial display - check for default selected option
updateSwatchDisplay();

        const sizeUnitsSelect = document.querySelector('.hulkapps_option_child.hulkapps_dd.hulk_po_dropdown');

        const option1 = document.querySelector(".option_type_id_1631085");
        const option2 = document.querySelector(".option_type_id_1631123");

        function toggleOptions() {
          const selectedValue = sizeUnitsSelect.value;
          
          if (selectedValue === 'Inches') {
            option1.style.display = 'block';
            option2.style.display = 'none';
          } else if (selectedValue === 'Centimeters') {
            option1.style.display = 'none';
            option2.style.display = 'block';
          } else {
            option1.style.display = 'none';
            option2.style.display = 'none';
          }
        }

        sizeUnitsSelect.addEventListener('change', toggleOptions);

        toggleOptions();
    }
  },150)
    setTimeout(()=>{
      clearInterval(hook);
    },10000)
});